export default "__VITE_ASSET__CcMA4bFq__"